import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d10123da"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "app-container" };
import { computed, getCurrentInstance, onMounted, onUnmounted, ref } from 'vue';
import DynamicDialog from 'primevue/dynamicdialog';
import ConfirmPopup from 'primevue/confirmpopup';
import Toast from 'primevue/toast';
import IframeLoader from '@apparatix/library/IframeLoader.vue';
import { AppStore } from '@apparatix/stores/AppStore';
import { useBackendDataConverter, useLegacyToastInterceptor, useUserPreferences, useStaticScript, useCrossFrameMessaging, } from '@apparatix/composables';
import AppHeader from '@apparatix/library/AppHeader.vue';
import Sidebar from '@apparatix/library/Sidebar.vue';
import CategoryHome from '@apparatix/library/CategoryHome.vue';
import PageNotImplemented from '@apparatix/library/PageNotImplemented.vue';
import ChangePasswordModal from '@apparatix/library/ChangePasswordModal.vue';
const SIDEBAR_OPEN_WIDTH = '256px';
const SIDEBAR_COLLAPSED_WIDTH = '65px';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Dashboard',
    props: {
        user: {},
        realUser: {},
        isImpersonating: { type: Boolean },
        companyLogo: {}
    },
    setup(__props) {
        const { modalStates } = useCrossFrameMessaging();
        useStaticScript('/res/dhx/3.6/dhtmlx.js');
        useLegacyToastInterceptor(getCurrentInstance().appContext.app);
        const { getPreferences } = useUserPreferences();
        const props = __props;
        const { navigationObjectToTopLevelNavigation } = useBackendDataConverter();
        const sidebarWidth = ref(SIDEBAR_OPEN_WIDTH);
        const enableSidebarCollapse = ref(false);
        (async () => {
            const preferences = await getPreferences();
            enableSidebarCollapse.value = preferences?.collapseSidebar ?? false;
            if (preferences?.collapseSidebar) {
                sidebarWidth.value = SIDEBAR_COLLAPSED_WIDTH;
            }
        })();
        AppStore.setCurrentUser(props.user);
        AppStore.realUser = props.realUser;
        AppStore.isImpersonating = props.isImpersonating;
        AppStore.navigationItems = navigationObjectToTopLevelNavigation(props.user.mainMenuItems);
        AppStore.companyLogo = props.companyLogo;
        if (AppStore.defaultPage) {
            AppStore.navigationItems?.find(page => page.label === AppStore.defaultPage)?.command();
        }
        const onSidebarResize = (isCollapsed) => {
            if (!enableSidebarCollapse.value)
                return;
            if (isCollapsed) {
                sidebarWidth.value = SIDEBAR_COLLAPSED_WIDTH;
            }
            else {
                sidebarWidth.value = SIDEBAR_OPEN_WIDTH;
            }
        };
        const containerWidthStyle = computed(() => {
            if (enableSidebarCollapse.value) {
                return {
                    width: AppStore.shouldShowSidebar ? `calc(100vw - ${SIDEBAR_COLLAPSED_WIDTH})` : '100vw',
                    marginLeft: AppStore.shouldShowSidebar ? SIDEBAR_COLLAPSED_WIDTH : '0',
                };
            }
            return { flexGrow: 1 };
        });
        const onSidebarPreferenceChange = (e) => {
            if (e.detail) {
                // The emitter for this event is in public/res/js/apx/main.js
                enableSidebarCollapse.value = e.detail.collapsed;
                if (e.detail.collapsed) {
                    sidebarWidth.value = SIDEBAR_COLLAPSED_WIDTH;
                }
                else {
                    sidebarWidth.value = SIDEBAR_OPEN_WIDTH;
                }
            }
        };
        const closeChangePasswordModal = () => modalStates.shouldOpenChangePassword = false;
        onMounted(() => {
            window.addEventListener('onSidebarPreferenceChange', onSidebarPreferenceChange);
        });
        onUnmounted(() => {
            window.removeEventListener('onSidebarPreferenceChange', onSidebarPreferenceChange);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(AppHeader, {
                    "root-navigation": props.user.mainMenuItems
                }, null, 8, ["root-navigation"]),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(Sidebar, {
                        "enable-collapse": enableSidebarCollapse.value,
                        width: sidebarWidth.value,
                        onSidebarCollapsed: onSidebarResize
                    }, null, 8, ["enable-collapse", "width"]),
                    _createElementVNode("section", {
                        style: _normalizeStyle(containerWidthStyle.value),
                        class: "iframe-container"
                    }, [
                        _createVNode(IframeLoader),
                        (_unref(AppStore).activeSubPage.isCategoryHome && !_unref(AppStore).showPageNotImplemented)
                            ? (_openBlock(), _createBlock(CategoryHome, { key: 0 }))
                            : _createCommentVNode("", true),
                        (_unref(AppStore).showPageNotImplemented)
                            ? (_openBlock(), _createBlock(PageNotImplemented, { key: 1 }))
                            : _createCommentVNode("", true)
                    ], 4)
                ]),
                _createVNode(ChangePasswordModal, {
                    open: _unref(modalStates).shouldOpenChangePassword,
                    "on-close": closeChangePasswordModal
                }, null, 8, ["open"]),
                _createVNode(_unref(ConfirmPopup)),
                _createVNode(_unref(DynamicDialog)),
                _createVNode(_unref(Toast))
            ], 64));
        };
    }
});
